<template>
  <section>
    <div class="row" v-if="messages">
      <!-- Messages -->
      <div ref="messages" class="col-lg-6 offset-lg-3 col-12 pt-0 container-chat-booking chat-messages">

        <div class="d-flex justify-content-start align-items-center bg-info p-1 mb-2 rounded text-white"
             v-if="$route.query.is_partner && $route.query.service_id && service">
          <div>
            <img :src="service.partner_picture ? service.partner_picture : service.picture"
                 alt=""
                 class="img-fluid rounded"
                 width="96">
          </div>
          <div class="flex-fill pl-3">
            <div>
              BeNeat แม่บ้านออนไลน์
            </div>
            <label for="" class="mb-0">
              {{ service | multiLangName }}
            </label>
          </div>
          <div class="text-right pr-2" v-if="service.id === 1 && partner && partner.name === 'LivingInsider'">
            <a href="" class="no-style text-white" @click.prevent="openPopupModal()">ดูรายละเอียด</a>
          </div>
        </div>

        <div class="bg-info sticky-top p-2 text-white text-center text-small shadow-sm"
             style="margin: 0 -2rem;"
             v-if="!$route.query.service_id && bookingData && bookingData.service_id">
          <i class="fas fa-circle text-warning"></i>
          คุณเลือก: {{ getService(Number(bookingData.service_id)).name_th }}
          <span v-if="partner"> | {{ partner.name }}</span>
        </div>

        <ul class="list-unstyled">
          <li v-for="(message, index) in messages">
            <message :message="message"/>
          </li>
        </ul>
      </div>
    </div>
    <div class="container-chat-booking" v-else>
      <div class="row p-5">
        <div class="col-12 text-center">
          <span class="text-loading">กำลังโหลด... กรุณารอสักครู่</span>
        </div>
      </div>
    </div>
    <!-- Popup Modal -->
    <popup-modal ref="popupModal"/>
    <!-- Cleaner Reviews Modal -->
    <cleaner-reviews-modal ref="cleanerReviewsModal"/>
    <!-- Service Detail Modal -->
    <service-detail-modal ref="serviceDetailModal"/>
    <!-- Vue Gallery Modal -->
    <Tinybox v-model="indexImage" :images="images" loop no-thumbs />
    <!-- Unvailable service area modal for booking experience -->
    <unavailable-service-area-modal ref="unavailableServiceAreaModal"/>
  </section>
</template>

<script>
  import { mapGetters, mapState, mapActions } from 'vuex'
  import { chatBookingMixin } from '../../mixins/chatBookingMixin'
  import { orderMixin } from '../../mixins/orderMixin'
  import CleanerReviewsModal from '../booking/components/CleanerReviewsModal'
  import Message from './Message'
  import PopupModal from './components/PopupModal'
  import ServiceDetailModal from '../chatBooking/components/ServiceDetailModal'
  import UnavailableServiceAreaModal from '../experience/components/UnavailableServiceAreaModal'
  import chatBookingHelpers from '../../helpers/chatBookingHelpers'
  import serviceHelpers from '../../helpers/serviceHelpers'
  
  export default {
    mixins: [chatBookingMixin, orderMixin],
    components: {
      CleanerReviewsModal,
      Message,
      PopupModal,
      ServiceDetailModal,
      UnavailableServiceAreaModal
    },
    data () {
      return {
        hostName: window.location.hostname,
        images: null,
        indexImage: null,
        service: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        payment: 'payment/getPayment',
        referralCodeOwner: 'referralCode/getReferralCodeOwner',
        user: 'auth/getUser'
      }),
      ...mapState('chatBooking', [
        'messages',
        'bookingData',
        'partner',
        'queryParams',
        'displayPopup'
      ])
    },
    watch: {
      'globalState.services': function () {
        if (this.$route.query.service_id && this.globalState.services) {
          const serviceId = Number(this.$route.query.service_id)
          this.service = this.globalState.services[serviceId]
        }
      },
      messages () {
        if (this.messages && this.messages.length) {
          let index = this.messages.length - 1
          if (this.messages[index] && this.messages[index].sender_type === 'user') {
            const messageData = this.messages[index]
            this.processMessageData(messageData)
          }
          this.scrollToBottom()
        }
      },
      partner () {
        if (!this.displayPopup && Number(this.$route.query.service_id) === 1 && this.partner && this.partner.name === 'LivingInsider') {
          this.openPopupModal()
          this.$store.commit('chatBooking/SET_DISPLAY_POPUP', true)
        }
      }
    },
    methods: {
      ...mapActions('chatBooking', ['fetchPartnerDetail']),
      openUnavailableServiceAreaModal () {
        this.$refs.unavailableServiceAreaModal.openModal()
      },
      openPopupModal () {
        this.$refs.popupModal.showPopupModal(true)
      },
      openGallery (images, index) {
        this.images = images
        this.indexImage = index
      },
      openProfessionalReviewsModal (professional) {
        const professionalData = {
          id: professional.id,
          name: professional.name,
          picture: professional.picture
        }
        this.$refs.cleanerReviewsModal.setProfessionalData(professionalData)
      },
      getService (serviceId) {
        for (const key in this.globalState.services) {
          const service = this.globalState.services[key]
          if (serviceId === service.id) {
            return service
          }
        }
      },
      scrollToBottom () {
        if (this.$refs.messages) {
          setTimeout(() => {
            this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
          }, 250)
        }
      },
      sendMessage (message) {
        const data = {
          sender_type: 'user',
          message: message
        }
        // alert(message)
        this.messages.push(data)
      },
      processMessageData (message) {
        this.manageFormData(message.data)
        if (message.serviceRequestData) {
          const params = {
            service_request: message.serviceRequestData
          }
          this.$store.commit('chatBooking/UPDATE_BOOKING_DATA', params)
        }
        let responseMessage = null
        const label = message.label
        switch (label) {
          case 'main-menu':
            chatBookingHelpers.replyMainMenu(this.user)
            break
          case 'reservation':
            // Route A: start with new booking
            this.$store.commit('chatBooking/SET_BOOKING_DATA', null)
            this.$store.commit('chatBooking/UPDATE_BOOKING_DATA', {route: 'new-booking'})
            if (this.user) {
              this.$store.commit('chatBooking/UPDATE_BOOKING_DATA', {user_id: this.user.id})
              const params = {user_id: this.user.id}
              chatBookingHelpers.getUserPlaces(params)
            } else {
              chatBookingHelpers.replyRegister()
            }
            break
          case 'otp':
            chatBookingHelpers.replyOTP(this.bookingData)
            break
          case 'cancel-user-place':
          case 'login':
            const params = {user_id: this.bookingData.user_id}
            // Route B: start with select professional
            if (this.bookingData.route === 'select-professional-first') {
              params.province_id = this.bookingData.province_id
            }
            chatBookingHelpers.getUserPlaces(params)
            break
          case 'request-logout':
            chatBookingHelpers.replyRequestLogout()
            break
          case 'logout':
            chatBookingHelpers.replyMainMenu(this.user)
            break
          case 'create-user-place':
            chatBookingHelpers.replyCreateUserPlace()
            break
          case 'selected-user-place':
            // Route A: start with new booking
            if (this.bookingData.route === 'new-booking') {
              // Check service id condition for partner 02/07/2021
              if (this.$route.query.is_partner && this.$route.query.service_id) {
                const serviceId = Number(this.$route.query.service_id)
                // Set booking data for selected service id
                this.$store.commit('chatBooking/UPDATE_BOOKING_DATA', {service_id: serviceId})
                const service = this.getService(serviceId)
                // Check is_service_request or not
                if (!service.is_service_request) {
                  chatBookingHelpers.getProfessionals(this.bookingData, this.globalState.services)
                } else {
                  chatBookingHelpers.replyCreateServiceRequestFirst()
                }
              } else {
                chatBookingHelpers.getServices(this.bookingData)
              }
            } else if (this.bookingData.route === 'select-professional-first') {
              // Route B: start with select professional
              const serviceId = Number(this.bookingData.service_id)
              if (serviceId === 1) {
                chatBookingHelpers.getWorkHours()
              } else {
                const params = {
                  serviceId: Number(this.bookingData.service_id),
                  provinceId: Number(this.bookingData.province_id),
                  services: this.globalState.services
                }
                chatBookingHelpers.getChildServices(params)
              }
            }
            break
          case 'my-professional':
            // Route B: start with select professional
            this.$store.commit('chatBooking/SET_BOOKING_DATA', null)
            this.$store.commit('chatBooking/UPDATE_BOOKING_DATA', {
              user_id: this.user.id,
              route: 'select-professional-first'
            })
            chatBookingHelpers.getProfessionals(this.bookingData, this.globalState.services)
            break
          case 'selected-service':
            // Route A: start with new booking
            if (this.bookingData.route === 'new-booking') {
              chatBookingHelpers.getProfessionals(this.bookingData, this.globalState.services)
            } else if (this.bookingData.route === 'select-professional-first') {
              const isAvailable = chatBookingHelpers.checkProfessionalAvailableService(this.bookingData)
              if (isAvailable) {
                // Route B: start with select professional
                const params = {
                  user_id: this.bookingData.user_id,
                  province_id: this.bookingData.province_id
                }
                chatBookingHelpers.getUserPlaces(params)
              } else {
                this.$swal({text: 'ผู้ให้บริการที่คุณเลือกล่าสุดไม่สามารถให้บริการนี้ได้'})
                this.$store.commit('chatBooking/REMOVE_MESSAGE')
              }
            }
            break
          case 'selected-service-request':
            // this.$refs.serviceDetailModal.openModal()
            chatBookingHelpers.replyCreateServiceRequestFirst()
            break
          case 'created-service-request':
            chatBookingHelpers.replyCreateServiceRequestSecond()
            break
          case 'cancel-service-request':
            chatBookingHelpers.getServices(this.bookingData)
            break
          case 'selected-professional':
            // Route A: start with new booking
            if (this.bookingData.route === 'new-booking') {
              chatBookingHelpers.getServiceSelection(this.bookingData, this.globalState.services)
            } else if (this.bookingData.route === 'select-professional-first') {
              // Route B: start with select professional
              chatBookingHelpers.getServices(this.bookingData)
            }
            break
          case 'selected-work-hour':
            chatBookingHelpers.replySelectDateTime()
            break
          case 'selected-date-time':
            const serviceId = Number(this.bookingData.service_id)
            let parentServiceId = 0
            if (this.globalState.services[serviceId].parent_id) {
              parentServiceId = this.globalState.services[serviceId].parent_id
            }
            // Deep-cleaning && bathroom cleaning
            const service = (parentServiceId) ? this.globalState.services[parentServiceId] : this.globalState.services[serviceId]
            const checkoutConditions = (service) ? service.checkout_conditions : null
            if (checkoutConditions && (checkoutConditions.allow_photo_attachment || checkoutConditions.allow_remark)) {
              chatBookingHelpers.replyAdditionalRemark()
            } else if (parentServiceId === 2 && this.globalState.configData.display_has_ironing_board) {
              chatBookingHelpers.replyHasIroningBoard()
            } else {
              this.createChatBooking()
            }
            break
          case 'selected-has-ironing-board':
          case 'saved-additional-remark':
            this.createChatBooking()
            break
          case 'select-payment-method':
            chatBookingHelpers.replyPaymentSelection(this.bookingData.id)
            break
          case 'credit-card-payment':
            chatBookingHelpers.replyCreditCardInformation()
            break
          case 'bank-transfer-payment':
            chatBookingHelpers.replyBankTransferInformation()
            break
          case 'change-payment-bank-transfer':
            chatBookingHelpers.replyChangePaymentMethod('change-payment-bank-transfer', message.data)
            break
          case 'promptpay-payment':
            chatBookingHelpers.replyPromptpayInformation()
            break
          case 'success-credit-card':
          case 'success-bank-transfer':
          case 'success-promptpay': {
            let text = 'ขอบคุณสำหรับการจองของคุณ คุณสามารถดูข้อมูลการจองของคุณได้จากปุ่มด้านล่าง'
            if (label === 'success-bank-transfer') {
              text = 'ขอบคุณสำหรับการจองของคุณ กรุณารอการตรวจสอบยอดโอนค่ะ โดยคุณจะได้รับการแจ้งเตือนอีกครั้งผ่านทางอีเมลค่ะ'
            }
            chatBookingHelpers.checkFinishBooking(this.user, text)
          }
            break
          case 'success-service-request': {
            const text = 'ขอบคุณสำหรับคำขอประเมินราคา และวันเข้าให้บริการของคุณ ทางทีมงานจะรีบดำเนินการ และติดต่อกลับให้เร็วที่สุดค่ะ'
            chatBookingHelpers.checkFinishBooking(this.user, text)
          }
            break
          case 'my-reservations':
            chatBookingHelpers.getOrders({user: this.user, status: 'upcoming'})
            break
          case 'my-reservations-history':
            chatBookingHelpers.getOrders({user: this.user, status: 'past'})
            break
          case 'view-order-detail':
            chatBookingHelpers.replyOrderDetail(message.data)
            break
          case 'view-service-request-detail':
            chatBookingHelpers.replyServiceRequestDetail(message.data)
            break
        }
        if (responseMessage) {
          setTimeout(() => {
            this.$store.commit('chatBooking/ADD_MESSAGE', responseMessage)
          }, 1000)
        }
      },
      manageFormData (data) {
        if (data) {
          if (typeof data === 'string') {
            const urlParams = new URLSearchParams(data)
            const params = Object.fromEntries(urlParams)
            this.$store.commit('chatBooking/UPDATE_BOOKING_DATA', params)
            if (params.save_data) {
              chatBookingHelpers.saveData(this.bookingData)
            }
          } else if (typeof data === 'object' && Array.isArray(data)) { // Case of selected service items e.g. ac-cleaning service
            const selectedServiceItems = []
            let workHours = 0.0
            for (const serviceItem of data) {
              selectedServiceItems.push({
                id: serviceItem.id,
                quantity: serviceItem.count
              })
              if (serviceItem.duration_conditions) {
                workHours += serviceHelpers.getServiceItemDuration(serviceItem.count, serviceItem)
              } else if (serviceItem.duration) {
                workHours += serviceItem.count * serviceItem.duration
              }
            }
            this.$store.commit('chatBooking/UPDATE_BOOKING_DATA', { service_items: selectedServiceItems, work_hour: workHours })
          }
        }
      },
      createChatBooking () {
        // Check referral code as partner project
        if (this.$route.query.ref || (this.$route.query.ref && this.$route.query.is_partner)) {
          this.$store.commit('chatBooking/UPDATE_BOOKING_DATA', {referral_code: this.$route.query.ref})
        }
        setTimeout(async () => {
          await chatBookingHelpers.createChatBooking(this.bookingData)
        }, 1000)
      }
    },
    async mounted () {
      let queryData = {unlimited_package: 1}
      if (this.user) {
        queryData.user_id = this.user.id
      }
      await this.$store.dispatch('globalVal/LOAD_GLOBAL_DATA', queryData)
      this.$store.commit('referralCode/SET_REFERRAL_CODE_OWNER', null)
      this.$store.commit('chatBooking/SET_PARTNER', null)
      if (!this.user && this.$route.query.c) {
        this.$store.dispatch('referralCode/LOAD_REFERRAL_CODE_OWNER', this.$route.query.c)
      } else if (this.$route.query.ref || (this.$route.query.ref && this.$route.query.is_partner)) {
        const queryParams = {
          referral_code: this.$route.query.ref
        }
        this.fetchPartnerDetail(queryParams)
      }
    },
    created () {
      if (this.$route.query) {
        this.$store.commit('chatBooking/SET_QUERY_PARAMS', this.$route.query)
      }
      if (this.$route.query.service_id && this.globalState.services) {
        const serviceId = Number(this.$route.query.service_id)
        this.service = this.globalState.services[serviceId]
      }
    }
  }
</script>

<style scoped>
  .bg-chat-messages {
    background-color: #FFFBFA;
  }

  .chat-messages {
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    height: 100vh;
    scroll-behavior: smooth;
    padding-bottom: 3rem;
  }

  .text-loading {
    font-size: 140%;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// src/components/chatBooking/Index.vue